module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/aaa55abd17e010a1ec92e3285b9b9f1d.png";